var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "yvg3r1pbka",
    d: "M12.778 7.273c.399 0 .722.325.722.727v5.818c0 1.205-.97 2.182-2.167 2.182H2.667C1.47 16 .5 15.023.5 13.818V8c0-.402.323-.727.722-.727.4 0 .722.325.722.727v5.818c0 .402.324.727.723.727h8.666c.4 0 .723-.325.723-.727V8c0-.402.323-.727.722-.727zM7 0h.016c.02 0 .04.002.06.004L7 0c.043 0 .085.004.126.011l.042.009c.022.005.043.011.064.018l.026.01c.02.008.041.017.061.027.011.005.022.01.033.017.019.01.037.022.055.035l.027.019.007.006.07.061 2.889 2.91c.282.283.282.744 0 1.028-.282.284-.74.284-1.022 0L7.722 2.482v7.7c0 .401-.323.727-.722.727-.399 0-.722-.326-.722-.727l-.001-7.699-1.655 1.668c-.282.284-.74.284-1.022 0-.282-.284-.282-.745 0-1.029L6.49.213l.069-.061.007-.006-.077.067c.033-.033.067-.061.104-.086.018-.013.036-.024.055-.035l.033-.017c.02-.01.04-.02.061-.027l.026-.01c.02-.007.042-.013.064-.018L6.874.01l.05-.007.06-.004H7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-328 -218) translate(40 218) translate(293 4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#yvg3r1pbka"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7cd8c815.svg";
export { ForwardRef as ReactComponent };